/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-20T19:56:10.853
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseAirCheck,
	listRentHouseAirCheckInit,
	listRentHouseAirCheckByAuthorizations,
	deleteRentHouseAirCheck
	
} from '@api/rentmanage/RentHouseAirCheck';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseAirCheck({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseAirCheck(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseAirCheckByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseAirCheckByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseAirCheckInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseAirCheckInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseAirCheck({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseAirCheck({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
